const FilterForm = () => {
  const handleFilterSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <form
      className="px-3"
      style={{ height: "88vh" }}
      onSubmit={handleFilterSubmit}
    >
      <div className="mb-3">
        <label htmlFor="visibleTaskList" className="custom-label">
          Visible Task List
        </label>
        <select id="visibleTaskList" className="form-select custom-field">
          <option selected></option>
          <option value="1">One</option>
          <option value="2">Two</option>
          <option value="3">Three</option>
        </select>
      </div>
      <div className="mb-3">
        <label htmlFor="visibleTaskList" className="custom-label">
          Assigned To
        </label>
        <select id="visibleTaskList" className="form-select custom-field">
          <option selected></option>
          <option value="1">One</option>
          <option value="2">Two</option>
          <option value="3">Three</option>
        </select>
      </div>
      <div className="mb-3">
        <label htmlFor="visibleTaskList" className="custom-label">
          Region
        </label>
        <select id="visibleTaskList" className="form-select custom-field">
          <option selected></option>
          <option value="1">One</option>
          <option value="2">Two</option>
          <option value="3">Three</option>
        </select>
      </div>
      <div className="mb-3">
        <label htmlFor="visibleTaskList" className="custom-label">
          Department
        </label>
        <select id="visibleTaskList" className="form-select custom-field">
          <option selected></option>
          <option value="1">One</option>
          <option value="2">Two</option>
          <option value="3">Three</option>
        </select>
      </div>
      <div className="row gap-1">
        <div className="col">
          <button type="submit" className="btn w-100 btn-green">
            Apply Filters
          </button>
        </div>
        <div className="col">
          <button type="reset" className="btn w-100 btn-grey">
            Reset Filters
          </button>
        </div>
      </div>
    </form>
  );
};

export default FilterForm;
